var site = site || {};
var generic = generic || {};
site.userInfoCookie = site.userInfoCookie || {};
site.userInfoCookie.getValue =
  site.userInfoCookie.getValue ||
  function () {
    return '';
  };
(function ($) {
  Drupal.behaviors.loyaltyJoinSigninV2 = {
    attach: function (context, settings) {
      var params;
      var isSignIn = 0;
      var isLoyalty = 0;
      var $allPanels,
        $defaultPanel,
        self,
        target,
        $toggleAccordion,
        $caretIcon,
        $accordionIcon,
        email = '';
      var isMobile = site.client.isMobile;
      var $container = $('.js-marketing-wrapper', context);
      var isLoyaltyMember = site.userInfoCookie.getValue('is_loyalty_member');
      var rendered = '';
      var loyaltySetting = settings?.loyalty || {};

      $(document).on('user.loaded', function (event, val) {
        if (!val.is_pro) {
          if (val.signed_in) {
            email = val.email_address;
            isSignIn = 1;
            if (isLoyaltyMember === '1') {
              isLoyalty = 1;
            }
          }
          var isOfferPage = $('.loyalty__offers__wrapper').length ? 1 : 0;

          params = {
            sign_in: isSignIn,
            loyalty: isLoyalty,
            email: email,
            is_offer_page: isOfferPage
          };
          var $LoyaltyUserModule;
          if (loyaltySetting.lr2021 && isSignIn && isLoyalty) {
            var updateUserModule = function () {
              var paramObj = {};
              if ($.cookie('csrftoken')) {
                paramObj._TOKEN = $.cookie('csrftoken');
              }
              $LoyaltyUserModule.addClass('is-updating');
              generic.jsonrpc.fetch({
                method: 'loyalty.user.get',
                params: [paramObj],
                onSuccess: function (response) {
                  if (typeof response.getValue().loyalty_level_next !== 'undefined') {
                    params.userCookie.points_to_next_level =
                      response.getValue().loyalty_level_next.needs.points_min;
                  }
                  $LoyaltyUserModule.removeClass('is-updating');
                }
              });
            };
            $LoyaltyUserModule = $('.marketing__wrapper--redesign2021 .js-user-status', context);
            params.userCookie = {};
            var userCookieFields = [
              'anniversary_date',
              'current_available',
              'is_loyalty_member',
              'loyalty_level',
              'loyalty_level_name',
              'next_level',
              'next_level_name',
              'points_to_next_level'
            ];
            $.each(userCookieFields, function (index, value) {
              params.userCookie[value] = site.userInfoCookie.getValue(value);
            });
            if (
              params.userCookie.next_level !== null &&
              params.userCookie.points_to_next_level === null
            ) {
              // if for some reason userCookie does not have needed values, lets try to fetch them and update user module content (LOYAL-9774)
              updateUserModule();
            }
            const $progressSection = $('.js-point-until', context);
            if (params.userCookie.loyalty_level > 2) {
              $progressSection.css('visibility', 'hidden').attr('aria-hidden', 'true');
            }
          }
          rendered = site.template.render($container.html(), params);
          $('.loyalty_join_signin_wrapper', context).html(rendered);
          /**
           * The js-mantle-lazy IntersectionObserver runs once at DOMContentLoaded.
           * The .html() call above destroys and recreates the DOM,
           * so the original video elements the observer was tracking are replaced.
           * This replicates the observer's logic for any orphaned lazy videos in the new DOM.
           */
          $('.loyalty_join_signin_wrapper video.js-mantle-lazy:visible', context).each(function () {
            this.getAttribute('data-autoplay') && this.setAttribute('autoplay', true);
            this.load();
            this.classList.remove('js-mantle-lazy');
            this.classList.add('js-mantle-lazy--processed');
          });
          if (loyaltySetting.lr2021 && isSignIn && isLoyalty) {
            // lets update background images for loyalty status and banner panels, this must be done after mustache render and context update
            const $imgOverlay = $('.js-image-overlay', context);
            const $imgOverlayMobile = $('.js-image-overlay-mobile', context);
            const $progressNode = $('.js-progress', context);
            let imageSrc;
            let imageSrcMobile;
            let progressValue;
            let progressMax;
            switch (params.userCookie.loyalty_level) {
              case '1':
                imageSrc = $imgOverlay.data('tier1');
                imageSrcMobile = $imgOverlayMobile.data('tier1');
                progressValue = params.userCookie.current_available;
                progressMax = 199;
                break;
              case '2':
                imageSrc = $imgOverlay.data('tier2');
                imageSrcMobile = $imgOverlayMobile.data('tier2');
                progressValue = params.userCookie.current_available - 199;
                progressMax = 399;
                break;
              case '3':
                imageSrc = $imgOverlay.data('tier3');
                imageSrcMobile = $imgOverlayMobile.data('tier3');
                break;
              default:
                imageSrc = '';
                imageSrcMobile = '';
                progressMax = '';
                progressValue = '';
            }
            if (imageSrc) {
              $imgOverlay.attr('src', imageSrc);
            }
            if (imageSrcMobile) {
              $imgOverlayMobile.attr('src', imageSrcMobile);
            }
            if (progressValue && progressMax) {
              $progressNode.attr('max', progressMax);
              $progressNode.attr('value', progressValue);
            }
          }
          if (isMobile) {
            $allPanels = $('.js-panel', context);
            $allPanels.hide();
            $accordionIcon = $('.accordion .icon', context);
            $defaultPanel = $('.marketing__benefits__section__content .js-panel', context);
            $defaultPanel.addClass('active').slideDown();
            $toggleAccordion = $('.js-accordion');
            $toggleAccordion.click(function () {
              self = $(this);
              $caretIcon = self.find('.icon', context);
              target = self.closest('.js-accordion').next();
              target.toggleClass('active');
              $accordionIcon.removeClass('icon-arrow_up').addClass('icon-arrow_down');
              if (!target.hasClass('active')) {
                $allPanels.removeClass('active').slideUp();
                $caretIcon.removeClass('icon-arrow_up').addClass('icon-arrow_down');
              } else {
                $allPanels.removeClass('active').slideUp();
                target.addClass('active').slideDown();
                $caretIcon.removeClass('icon-arrow_down').addClass('icon-arrow_up');
              }
            });
          }
        }
      });
    }
  };
})(jQuery);
